import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/281eec7f-7607-42e9-83df-7e71a8292f03";
export const REGISTER_URL = "https://a.ntrk2.com/8da1162d-3a36-4a53-82f0-a6a042ea1a6e";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://winoro.loadprkw2a.com/download?openExternalBrowser=1&id=yj1ald7ssnplqax";

export * from "./codes";
export * from "./context";
